import React, { useState } from 'react';
import axios from 'axios'; // Asegúrate de tenerlo arriba
import ModalTailwind from '../../components/ModalTailwind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function SolicitudNewPassword() {
  const [correo, setCorreo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ mensaje: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await axios.post(
            'https://www.fancyplus.digital/api/users/forgot-password',
                { email: correo },
                { withCredentials: true }
            );

            setModalInfo({
                mensaje: 'Se ha enviado un enlace a tu correo electrónico para recuperar tu contraseña.',
            });
            setShowModal(true);
            setCorreo('');
        } catch (err) {
            if (err.response?.status === 404) {
                setModalInfo({
                    mensaje: 'Correo no encontrado en el sistema',
                });
            } else {
                setModalInfo({
                    mensaje: 'Ocurrió un error al intentar enviar el correo. Intenta más tarde.',
                });
            }
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };

  return (
    <div className="min-h-screen flex justify-center items-start pt-10">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md flex flex-col gap-4"
      >
        <h2 className="text-xl font-bold text-center mb-4">Recuperación de Contraseña</h2>

        <label className="block">Correo con el que te registraste:</label>
        <input
          type="email"
          name="correo"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          required
          className="w-full p-2 border rounded mb-2"
          placeholder="ejemplo@correo.com"
        />

        <div className="relative inline-block w-full">
          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            Recuperar contraseña
          </button>

          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded">
              <div className="w-5 h-5 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
        </div>
      </form>

      {/* Modal de confirmación */}
      <ModalTailwind show={showModal} onClose={() => setShowModal(false)} title="Éxito">
        <p className="text-gray-700 mb-4">{modalInfo.mensaje}</p>
        <div className="flex justify-end">
          <button
            onClick={() => setShowModal(false)}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Aceptar
          </button>
        </div>
      </ModalTailwind>
    </div>
  );
}
